import { useQuery } from '@tanstack/react-query';
import { QueryKey } from 'api/model';
import { getGlobalFolders, getProjectFolders } from './requests';

const queryKey = QueryKey.PythonFunctionFolders;

const usePythonFunctionFolders = (projectId: string | null = null, includeGlobalFolders = true, enabled = true) => {
  const queryFn = () => (projectId === null ? getGlobalFolders() : getProjectFolders(projectId, includeGlobalFolders));

  const { data: folders, isLoading } = useQuery({
    queryKey: [queryKey, { projectId, includeGlobalFolders }],
    queryFn,
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled,
  });

  return { folders: folders ?? [], isLoading };
};

export { queryKey };
export default usePythonFunctionFolders;
